var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c("div", { staticClass: "relative" }, [
        _c("textarea", {
          ref: _vm.focus ? _vm.name : false,
          staticClass:
            "\n        mt10 pb10 px15 w-100 border-box brdr-1\n        brdr-cl-black h4 sans-serif\n      ",
          class: { empty: _vm.value === "" },
          attrs: {
            type: _vm.type,
            name: _vm.name,
            autocomplete: _vm.autocomplete,
            autofocus: _vm.autofocus,
            placeholder: _vm.placeholder
          },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event.target.value)
            },
            blur: function($event) {
              return _vm.$emit("blur")
            },
            keyup: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$emit("keyup.enter", $event.target.value)
              },
              function($event) {
                return _vm.$emit("keyup", $event)
              }
            ]
          }
        })
      ]),
      _vm._v(" "),
      _vm.validations
        ? _c("ValidationMessages", { attrs: { validations: _vm.validations } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }